import React from "react";
import PropTypes from "prop-types";
import { cn } from "../cn";
import styles from "./Button.module.scss";

/**
 * Button primitive.
 * variant: primary (solid) | secondary (ghost + border) | ghost | destructive
 * size:    sm | md | lg
 */
const Button = React.forwardRef(function Button(
  {
    variant = "primary",
    size = "md",
    type = "button",
    fullWidth = false,
    leftIcon = null,
    rightIcon = null,
    className,
    children,
    ...rest
  },
  ref
) {
  return (
    <button
      ref={ref}
      type={type}
      className={cn(
        styles.btn,
        styles[variant],
        styles[size],
        fullWidth && styles.fullWidth,
        className
      )}
      {...rest}
    >
      {leftIcon ? <span className={styles.icon}>{leftIcon}</span> : null}
      {children}
      {rightIcon ? <span className={styles.icon}>{rightIcon}</span> : null}
    </button>
  );
});

Button.propTypes = {
  variant: PropTypes.oneOf(["primary", "secondary", "ghost", "destructive"]),
  size: PropTypes.oneOf(["sm", "md", "lg"]),
  type: PropTypes.string,
  fullWidth: PropTypes.bool,
  leftIcon: PropTypes.node,
  rightIcon: PropTypes.node,
  className: PropTypes.string,
  children: PropTypes.node,
};

export default Button;
